import { render, staticRenderFns } from "./MoveBar.vue?vue&type=template&id=52b6d061"
import script from "./MoveBar.vue?vue&type=script&lang=js"
export * from "./MoveBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports